module.exports = __webpack_public_path__ + "io-bottom-bw.svg?2b7ec67edee69698383a834b9221f3fe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/io-bottom-bw.svg
// module id = 87
// module chunks = 0